var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstAidKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property Detail - Pricng detail closed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3741,
    transform: "translate(-120 -1817)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "medical-box 1",
    clipPath: "url(#clip0_125_1901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.197 3.04679H11.9219V1.55682C11.9219 0.889943 11.3793 0.347412 10.7125 0.347412H5.2875C4.62066 0.347412 4.07812 0.889943 4.07812 1.55682V3.04679H1.80303C0.808844 3.04679 0 3.85563 0 4.84982V13.8496C0 14.8438 0.808844 15.6526 1.80303 15.6526H14.197C15.1912 15.6526 16 14.8438 16 13.8496V4.84982C16 3.85563 15.1912 3.04679 14.197 3.04679ZM5.07812 1.55682C5.07812 1.44332 5.174 1.34741 5.2875 1.34741H10.7125C10.826 1.34741 10.9219 1.44329 10.9219 1.55682V3.04679H5.07812V1.55682ZM15 13.8496C15 14.2923 14.6398 14.6526 14.197 14.6526H1.80303C1.36022 14.6526 1 14.2923 1 13.8496V4.84982C1 4.40704 1.36022 4.04679 1.80303 4.04679H14.197C14.6398 4.04679 15 4.40701 15 4.84982V13.8496ZM11.125 7.6661H9.68359V6.22469C9.68359 5.94857 9.45972 5.72469 9.18359 5.72469H6.81644C6.54031 5.72469 6.31644 5.94857 6.31644 6.22469V7.6661H4.875C4.59888 7.6661 4.375 7.88997 4.375 8.1661V10.5333C4.375 10.8094 4.59888 11.0333 4.875 11.0333H6.31641V12.4747C6.31641 12.7508 6.54028 12.9747 6.81641 12.9747H9.18356C9.45969 12.9747 9.68356 12.7508 9.68356 12.4747V11.0333H11.125C11.4011 11.0333 11.625 10.8094 11.625 10.5333V8.1661C11.625 7.88997 11.4011 7.6661 11.125 7.6661ZM10.625 10.0333H9.18359C8.90747 10.0333 8.68359 10.2571 8.68359 10.5333V11.9747H7.31644V10.5333C7.31644 10.2571 7.09256 10.0333 6.81644 10.0333H5.375V8.6661H6.81641C7.09253 8.6661 7.31641 8.44222 7.31641 8.1661V6.72469H8.68356V8.1661C8.68356 8.44222 8.90744 8.6661 9.18356 8.6661H10.625V10.0333Z",
    fill: "#01152E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_1901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAidKit);
export default __webpack_public_path__ + "static/media/first-aid-kit.ae033df2468439e735eee7c83518eac0.svg";
export { ForwardRef as ReactComponent };